$(document).ready(function () {
    // Nav toggle
    (function () {
        $(".nav-toggle").click(function () {
            $(".site-nav").slideToggle();
            $(this).toggleClass("open");
        });
    })();

    // Item toggle
    (function () {
        $(".media--details__button").click(function (e) {
            e.preventDefault();
            $(this).closest(".media--details__items").find(".media--details__descriptions").show();
            var myID = $(this).attr("href");
            $(this).siblings(".media--details__button").removeClass("active");
            $(this).addClass("active");
            $(this)
                .closest(".media--details__items")
                .find(".media--details__description")
                .removeClass("active");
            $(this)
                .closest(".media--details__items")
                .find(myID)
                .addClass("active");
        });
    })();

    // Item toggle hover
    (function () {
        $(".media--details__button").hover(function (e) {
            e.preventDefault();
            $(this)
                .closest(".media--details__items")
                .find(".media--details__descriptions")
                .show();
            var myID = $(this).attr("href");
            $(this).siblings(".media--details__button").removeClass("active");
            $(this).addClass("active");
            $(this)
                .closest(".media--details__items")
                .find(".media--details__description")
                .removeClass("active");
            $(this)
                .closest(".media--details__items")
                .find(myID)
                .addClass("active");
        });
    })();

    $(".carousel").slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        // centerMode: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    // $(".propertyhive-featured-properties-shortcode .properties").slick({
    //     infinite: true,
    //     slidesToShow: 5,
    //     slidesToScroll: 1,
    //     dots: true,
    //     arrows: false,
    //     // centerMode: true,
    //     responsive: [
    //         {
    //             breakpoint: 1200,
    //             settings: {
    //                 slidesToShow: 4,
    //                 slidesToScroll: 1,
    //             },
    //         },
    //     ],
    // });

    // $(".propertyhive-similar-properties-shortcode .properties").slick({
    //     infinite: true,
    //     slidesToShow: 5,
    //     slidesToScroll: 1,
    //     dots: true,
    //     arrows: false,
    //     // centerMode: true,
    //     responsive: [
    //         {
    //             breakpoint: 1200,
    //             settings: {
    //                 slidesToShow: 4,
    //                 slidesToScroll: 1,
    //             },
    //         },
    //     ],
    // });

    $(".counter").countUp();

    $(".reviews__items").slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        centerMode: false,
        adaptiveHeight: true,
    });

    $(".tab__button").click(function (e) {
        e.preventDefault();
        var myID = $(this).attr("href");
        $(".tab__button").removeClass("active");
        $(this).addClass("active");
        $(".tab__panel").removeClass("active");
        $(myID).addClass("active");
    });

    // Toggle Categories
    $(".selector").on("click", function () {
        $(".cat-list").toggleClass("show");
        $(".news-list").toggleClass("show");
        $(this).toggleClass("active");
    });
    $(".cat-list_item").on("click", function () {
        $(".cat-list_item").removeClass("active");
        $(this).addClass("active");
        $(".cat-list").removeClass("show");
        var selected = $(this).text();
        $(".selector").text(selected);
        $(".selector").removeClass("active");
        $("#LoadingImage").show();
        $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            dataType: "html",
            data: {
                action: "filter_projects",
                category: $(this).data("slug"),
            },
            success: function (res) {
                $("#caseStudiesWrapper").html(res);
                $("#LoadingImage").hide();
            },
        });
    });

    $(".news-list_item").on("click", function () {
        $(".news-list_item").removeClass("active");
        $(this).addClass("active");
        $(".news-list").removeClass("show");
        var selected = $(this).text();
        $(".selector").text(selected);
        $(".selector").removeClass("active");
        $("#LoadingImage").show();
        $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            dataType: "html",
            data: {
                action: "filter_news",
                category: $(this).data("slug"),
            },
            success: function (res) {
                $("#newsWrapper").html(res);
                $("#LoadingImage").hide();
            },
        });
    });

    $(".load-all-map").on("click", function () {
        var myLong = $(this).data("long");
        var mylat = $(this).data("lat");
        loadLocratingPlugin({
            id: "allmap",
            lat: mylat,
            lng: myLong,
            type: "all",
        });
    });

    $(".load-school-map").on("click", function () {
        var myLong = $(this).data("long");
        var mylat = $(this).data("lat");
        loadLocratingPlugin({
            id: "schoolmap",
            lat: mylat,
            lng: myLong,
            type: "schools",
        });
    });

    $(".frame").each(function() {
        var $frame = $(this);
        var $wrap = $frame.parent();
        $frame.sly({
            horizontal: 1,
            itemNav: "basic",
            smart: 1,
            activateOn: "click",
            mouseDragging: 1,
            touchDragging: 1,
            releaseSwing: 1,
            startAt: -1,
            scrollBar: $wrap.find(".scrollbar"),
            scrollBy: 1,
            pagesBar: $wrap.find(".pages"),
            activatePageOn: "click",
            speed: 300,
            elasticBounds: 1,
            dragHandle: 1,
            dynamicHandle: 1,
            clickBar: 1,
        });
    });
});
